/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, input, OnInit, output } from '@angular/core';
import { ControlValueAccessor, FormControl, FormControlStatus, NG_VALUE_ACCESSOR, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { ErrorMessagePipe } from '@presentation/landing/component/check-offers/components/input-msisdn/error-message.pipe';

@Component({
  selector: 'app-input-email',
  standalone: true,
  imports: [ReactiveFormsModule, ErrorMessagePipe, TranslatePipe],
  templateUrl: './input-email.component.html',
  styleUrl: './input-email.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: InputEmailComponent,
      multi: true
    }
  ]
})
export class InputEmailComponent implements ControlValueAccessor, OnInit {
  placeholder = input<string>();
  isValid = output<boolean>();

  control: FormControl = new FormControl('', [Validators.email]);

  onChange: (value: any) => void = () => {};
  onTouched: () => void = () => {};

  ngOnInit(): void {
    this.control.statusChanges.subscribe({
      next: (status: FormControlStatus) => {
        this.isValid.emit(status === 'VALID');
      }
    });
  }

  writeValue(obj: any): void {
    this.control.setValue(obj);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onInput(event:Event) {
    const INPUT = event.target as HTMLInputElement;
    this.onChange(INPUT.value);
  }

}
